import SidebarAppMenu from "./MainComponent.vue";
import type { ComputedRef, InjectionKey, Ref } from "vue";

export const menuKey = Symbol() as InjectionKey<Ref<SidebarParent[]>>;
export const sidebarColorKey = Symbol() as InjectionKey<ComputedRef<string>>;
export const isSidebarExpandedKey = Symbol() as InjectionKey<Ref<boolean>>;

export enum SearchItemType {
  ORDER = "order",
  INCIDENCE = "incidence",
  LINEHAUL = "linehaul",
  DEDICATED_SERVICE = "dedicated-service",
}

export interface SearchItem {
  type: SearchItemType;
  route_key: string;
  value: string;
  display_values: {
    reference: string;
    value: string;
    client: string;
    operation: string;
  };
}

export interface Widget {
  getUnseenCount: () => number;
  toggle: () => void;
}

export interface ChangeEvent<T = unknown> {
  target: T;
  to: T;
  from: {
    children: HTMLElement[];
  };
  newIndex: number;
  added?: {
    element: T;
    newIndex: number;
  };
  removed?: {
    element: T;
    oldIndex: number;
  };
  moved?: {
    element: T;
    oldIndex: number;
    newIndex: number;
  };
}

export const sectionSortTemplate = ["orders", "alerts", "incidences"];

export default SidebarAppMenu;
